/** @format */

import React, { useState } from "react";
import CustomModal from "../../core/modal";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Checkbox from "@mui/material/Checkbox";
import Stack from "@mui/material/Stack";
import Select from "react-select";
import EditIcon from "@mui/icons-material/Edit";
import { invokeApi, HTTP_METHODS } from "../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../utils/endpoints";
import { toast } from "react-toastify";
import { STATES, INDUSTRY } from "./helper";
import { Avatar, FormControlLabel, FormGroup, IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

import CustomButtonComponent from "../../core/custom-button";
import { PAGE_LIMIT } from "../../utils";
const OemActionIcons = ({
  id,
  Code,
  Address,
  LoadData,
  Name,
  Industry,
  admin,
  Email,
  phoneNo,
}) => {
  const [edit, setEdit] = useState(false);
  const [del, setDel] = useState(false);
  const [name, setName] = useState(Name);
  const [code, setCode] = useState(Code);
  const [email, setEmail] = useState(Email);
  const [address, setAddress] = useState(Address?.line1);
  const [country, setCountry] = useState(Address?.country);
  const [district, setDistrict] = useState(Address?.district);
  const [phoneNumber, setPhoneNumber] = useState(phoneNo || "");
  const [state, setState] = useState(Address?.state);
  const [isAdmin, setIsAdmin] = useState(false);
  const [error, setError] = useState(false);
  const [helperText, setHelperText] = useState("");
  const [password, setPassword] = useState(""); // Add this line
  // const [industry, setIndustry] = useState(Industry);
  const editHandler = () => {
    setName(Name);

    setCode(Code);

    setAddress(Address?.line1);

    setState(Address?.state);

    // setIndustry(Industry);

    setDistrict(Address?.district);
    setIsAdmin(admin);
    setCountry(Address?.country);
    setPhoneNumber(phoneNo);
    setPassword("");
    setEdit(true);
  };
  const deleteHandler = () => {
    setDel(true);
  };
  const addPhoneNumberHandler = (event) => {
    const value = event.target.value;
    setPhoneNumber(value);
    const phoneRegex = /^[0-9]{10}$/;

    if (value && !phoneRegex.test(value)) {
      setError(true);
      setHelperText("Phone number must be 10 digits");
    } else {
      setError(false);
      setHelperText("");
    }
  };
  const addNameHandler = (event) => {
    setName(event.target.value);
  };
  const addCodeHandler = (event) => {
    setCode(event.target.value);
  };
  const addAddressHandler = (event) => {
    setAddress(event.target.value);
  };
  const addStateHandler = (event) => {
    setState(event.label);
  };
  // const addIndustryHandler = (event) => {
  //   setIndustry(event.label);
  // };
  const addDistrictHandler = (event) => {
    setDistrict(event.target.value);
  };
  const addCountryHandler = (event) => {
    setCountry(event.target.value);
  };
  const buildPayload = () => {
    const basePayload = {
      name: name,
      code: code,
      address: {
        line1: address,
        district: district,
        state: state,
        country: country,
      },
      admin: isAdmin,
      email: email,
      phoneNumber: phoneNumber,
    };
    if (password && password.trim() !== "") {
      basePayload.password = password;
    }
    return basePayload;
  };

  //Edit Oem
  const editOemHandler = () => {
    invokeApi(
      HTTP_METHODS.PUT,
      `${HOSTNAME}${REST_URLS.OEMS}/abc/${id}`,
      buildPayload()
    )
      .then((response) => {
        if (response.message) {
          toast.error(response.message);
        } else {
          LoadData({ page: 1, limit: PAGE_LIMIT, sortBy: "-createdAt" });
          setEdit(false);
        }
      })
      .catch((err) => console.error(err));
  };
  //Delete Oem
  const deleteOemHandler = () => {
    const payload = { active: false };
    invokeApi(
      HTTP_METHODS.PUT,
      `${HOSTNAME}${REST_URLS.OEMS}/abc/${id}`,
      payload
    )
      .then((response) => {
        if (response.message) {
          toast.error(response.message);
        } else {
          LoadData({ page: 1, limit: PAGE_LIMIT, sortBy: "-createdAt" });
          setDel(false);
        }
      })
      .catch((err) => console.error(err));
  };
  let closeEditModal = () => {
    setEdit(false);
  };
  let CloseDeleteModal = () => {
    setDel(false);
  };
  return (
    <div>
      <Stack direction="row" spacing={2}>
        <IconButton sx={{ p: 0, pl: 1 }} onClick={editHandler}>
          <EditIcon color="primary" />
        </IconButton>

        <IconButton onClick={deleteHandler} id="delete" sx={{ p: 0 }}>
          <DeleteIcon color="error" />
        </IconButton>
      </Stack>
      {edit && (
        <CustomModal title="Edit Oem " onClose={closeEditModal}>
          <Box
            sx={{
              width: 500,
              maxWidth: "100%",
            }}
          >
            <TextField
              fullWidth
              id="name"
              label="Name"
              sx={{ mb: 1 }}
              rows={4}
              onChange={addNameHandler}
              value={name}
              size="small"
            />

            <TextField
              fullWidth
              id="code"
              label="Code"
              sx={{ mb: 1 }}
              rows={4}
              onChange={addCodeHandler}
              value={code}
              size="small"
            />
            <TextField
              fullWidth
              id="email"
              label="Email"
              sx={{ mb: 1 }}
              onChange={(e) => setEmail(e.target.value)}
              value={email}
              type="email"
              size="small"
            />
            <TextField
              fullWidth
              id="phoneNumber"
              label="Phone Number"
              sx={{ mb: 1 }}
              onChange={addPhoneNumberHandler}
              value={phoneNumber}
              type="number"
              size="small"
              error={error}
              helperText={helperText}
            />
            <TextField
              fullWidth
              id="address"
              label="Address"
              sx={{ mb: 1 }}
              rows={4}
              onChange={addAddressHandler}
              value={address}
              size="small"
            />
            <TextField
              fullWidth
              id="district"
              label="District"
              sx={{ mb: 1 }}
              rows={4}
              onChange={addDistrictHandler}
              value={district}
              size="small"
            />
            <TextField
              id="country"
              label="Country"
              sx={{ mb: 1 }}
              rows={4}
              onChange={addCountryHandler}
              value={country}
              size="small"
              fullWidth
            />

            <div className="oem-drop-downs-c">
              {/* <Select
                value={industry}
                classNamePrefix="si-select"
                options={INDUSTRY}
                onChange={addIndustryHandler}
                placeholder={industry !== "" ? industry : "Domain"}
              /> */}

              <Select
                value={state}
                classNamePrefix="si-select"
                options={STATES}
                onChange={addStateHandler}
                placeholder={state !== "" ? state : "State"}
              />
            </div>
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={isAdmin}
                    onChange={(e) => {
                      setIsAdmin(e.target.checked);
                    }}
                  />
                }
                label="Is Admin"
              />
            </FormGroup>
            <TextField
              fullWidth
              id="password"
              label="Reset Password"
              sx={{ mb: 1 }}
              onChange={(e) => setPassword(e.target.value)}
              value={password}
              type="password"
              size="small"
              placeholder="Enter new password"
              autoComplete="new-password"
            />
            <Stack
              direction="row"
              spacing={2}
              sx={{ mt: 3, ml: 0, justifyContent: "space-between" }}
            >
              <CustomButtonComponent
                variant="outlined"
                color="error"
                fullWidth
                onClick={() => {
                  closeEditModal(false);
                }}
              >
                Cancel
              </CustomButtonComponent>
              <CustomButtonComponent
                variant="contained"
                color="primary"
                fullWidth
                onClick={editOemHandler}
              >
                Save
              </CustomButtonComponent>
            </Stack>
          </Box>
        </CustomModal>
      )}
      {del && (
        <CustomModal title="Confirm Delete" onClose={CloseDeleteModal}>
          <h3>Are you sure to delete this item?</h3>
          <Stack
            direction="row"
            spacing={2}
            sx={{ justifyContent: "flex-end" }}
          >
            <CustomButtonComponent
              variant="outlined"
              onClick={() => setDel(false)}
            >
              Cancel
            </CustomButtonComponent>
            <CustomButtonComponent
              variant="contained"
              color="error"
              onClick={deleteOemHandler}
            >
              Delete
            </CustomButtonComponent>
          </Stack>
        </CustomModal>
      )}
    </div>
  );
};
export default OemActionIcons;
